angular.module('mtic.components.modules').
directive('c4Module1', function (
  GR78_ASSET_URL,
  C4_ASSET_URL,
  DEV_VARIABLES,
  StudentDataService,
  TeacherDataService,
  PanelStateService,
  $timeout,
  TIMING_CONSTANTS,
  $q,
  $log,
  $http,
  $window,
  gr78MapItemFactory,
  MapDataMassage,
  MapStateService,

  VerletSystemService,
  learningMapUtil,
  PIXI,
  EventManager,
  flashPermission,
  language,
  userAccount,
  api,
  preliveCheck,
  SessionDataService,
  LocaleService,
  IAMManager,
  ModuleFilter,
  PlatformService
) {

  return {

    templateUrl: 'template.html',
    scope: {
      moduleMapData: "=",
      interceptClick: "=?",
      onItemClick: "<",
      workspaceData:"=?",
      interactionDisabled:"=?"
    },
    link: function(scope, element) {

      scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;

      var middle_view_visible = false;

      var eventManager = new EventManager('gr78MetaMap', scope);
      var userData = userAccount.getData();
      scope.isTeacher = userAccount.getData().role.isTeacher;

      function checkForStudentTest(){
        //asssessment bubble stuff
        showing_student_assesment = false;
        var userData = userAccount.getData();
        var token_saved_url = IAMManager.getSavedUrlParamsForToken();

        // $log.log("Locale saved baseline/quest: ", LocaleService.hasCompletedStudentBase, LocaleService.hasCompletedStudentQuest);

        var group_id = userData.role.isTeacher ? scope.moduleMapData.class_id : userAccount.getActiveClassroom();//userAccount.getActiveClassroom();//
        var app_link;

        var is_app = window.isWebEmbedConnect || window.location.href.indexOf('web-embed-connect') !== -1 || token_saved_url.indexOf('web-embed-connect') !== -1;

        // if(!scope.interceptClick && is_app && !PlatformService.isIos){
        //     scope.badBrowser = false;
        //     // $log.log('using updated version : ', window.isUpdatedVersion)
        //     if(!navigator.userAgent.match(/Android/i) && (window.location.href.indexOf('?redirect-from-prelive') > -1 || window.updatedVersion)){
        //       app_link = 'http://mthmtc.vretta.com/qc/mtic_v2/pre-live/dist/?web-embed-response&user_id='+userData.user_id+'&session_key='+userData.sessionKey+'&group_id='+group_id+'&is_teacher='+userData.role.isTeacher+'&current_language='+language.getCurrentSelectedLanguage();
        //     }else{
        //       //older version OR android
        //       var firstDelim = /\?/.test(window.location.href) ? '&' : '?';
        //       app_link = window.location.href + firstDelim + 'web-embed-response&user_id='+userData.user_id+'&session_key='+userData.sessionKey+'&group_id='+group_id+'&is_teacher='+userData.role.isTeacher+'&current_language='+language.getCurrentSelectedLanguage();
        //     }

        //     eventManager.broadcast('change-prelive-message', app_link.replace('#&', '#/web-embed-connect&'))
        //     window.location.href = app_link.replace('#&', '#/web-embed-connect&');
        //     $timeout(function(){
        //       userAccount.logout();
        //     },100)

        //     return;
        // }else{
        //   if (group_id !== 4594){ // TODO: apply group settings and read from there rather than hard-coding test C4 class like this
        //     // if (!scope.interceptClick && ((navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent)) && !window.MSStream)){
        //     //   //This is an android or ios device visiting the page NOT in the mathematic app
        //     //   scope.badBrowser = true;
        //     //   return;
        //     // }
        //   }
          init();
          scope.inited = true;
        // }
      }

      // event manager for coordination with rest of application
      var verlet_system = new VerletSystemService();
      // var assessment_bubble;
      var showing_student_assesment = false;
      ///////////////////
      // PRIVATE VARS //
      /////////////////
      ///
      // var student_baseline = {
      //   hostUrl: 'https://d3kdl9636cazwt.cloudfront.net/containers/inbook/v2.4.66/index.html?host=cloudfront&repo=mtic_baseline_assessment&cloudfrontVersion=v1.0.6',
      //   module_id: 57,
      //   slug: 'mtic_baseline_assessment',
      //   id: 1244,
      //   resources: '',
      //   class_id: null,
      // }

      var state = 0;
      var canvas_el = null;
      var app = null;
      var renderer = null;
      var drag_info = null;
      var canvasDimention = null;
      var scale = null;
      var stage = null;
      var meta_gradient = null;
      var meta_bg = null;
      var repeating_clouds = null;
      var container = null;
      var meta_container = null;
      var lines_graphic = null;
      var selection_graphic = null;
      var cloud_man = null;
      var items = [];
      var modules = [];
      var img_asset_paths = [
        GR78_ASSET_URL + "symlink.png",
        GR78_ASSET_URL + "item_blue_0.png",
        GR78_ASSET_URL + "item_blue_1.png",
        GR78_ASSET_URL + "item_red_0.png",
        GR78_ASSET_URL + "item_red_1.png",
        GR78_ASSET_URL + "item_red_2.png",
        GR78_ASSET_URL + "item_red_3.png",
        GR78_ASSET_URL + "item_black_0.png",
        GR78_ASSET_URL + "item_black_1.png",
        GR78_ASSET_URL + "item_black_2.png",
        GR78_ASSET_URL + "item_black_3.png",
        GR78_ASSET_URL + "item_blue_locked.png",
        GR78_ASSET_URL + "item_red_locked.png",
        GR78_ASSET_URL + "item_black_locked.png",
        GR78_ASSET_URL + "assessment.png",
        GR78_ASSET_URL + "assessment_complete.png",
        GR78_ASSET_URL + "selection.png",
        GR78_ASSET_URL + "formative_gold.png",
        GR78_ASSET_URL + "formative_silver.png",
        GR78_ASSET_URL + "formative_locked.png",
        GR78_ASSET_URL + "formative_unlocked.png",
      ];

      var c4_asset_paths = [
        C4_ASSET_URL + 'background.png',
        C4_ASSET_URL + 'background_clouds.png',
        C4_ASSET_URL + 'c4_m1.png',
        C4_ASSET_URL + 'c4_m2.png',
        C4_ASSET_URL + 'c4_m3.png',
        C4_ASSET_URL + 'c4_m4.png',
        C4_ASSET_URL + 'c4_m5.png',
        C4_ASSET_URL + 'c4_m6.png'
      ];

      var focus_item = null;
      var CANVAS_EL_ID = 'canvas-c4-module-m1';
      var isMobile = (navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent));

      // scope.show_baseline_test_prompt = false;
      // var baseline_to_true = function(){
      //   if(student_baseline.slug === 'mtic_student_onboarding'){
      //     eventManager.broadcast('navbar:teacher-test:click', {isStudentTest: true});
      //   }else{
      //     scope.show_baseline_test_prompt = true;
      //   }
      //   scope.$apply();
      // }

      scope.hasAgendas = false;

      flashPermission.getPermission();

      var runDownModel = {}
      var highlightedItem = null;
      var resourceLockManager = (function ResourceLockManager(self){
        var originalLockState = {};
        self.setOriginal = function(resourceId, isLocked){
          if(!originalLockState[resourceId]) {
            originalLockState[resourceId] = isLocked;
          }
        }
        self.unlock = function(resourceIds) {
          self.reset();
          resourceIds.forEach(function(resourceId){
            var item = getItemById(resourceId);
            if(item) {
              item.unlock();
            }
          })
        }
        self.lock = function(resourceIds) {
          self.reset();
          resourceIds.forEach(function(resourceId){
            var item = getItemById(resourceId);
            if(item) {
              item.lock();
            }
          })
        }
        self.reset = function() {
          items.forEach(function(item){
            if(originalLockState[item.id] === true) {
              item.lock();
            } else if(originalLockState[item.id] === false) {
              item.unlock();
            }
          })
        }
        return self;
      })({})

      scope.showAgenda = false;
      scope.selectedResource = {};
      function unlockpath(item_id, use_slug){
        // $log.log('UNLOCK PATH : ', item_id, items )
        items.forEach(function(resource){
          if(resource.id === item_id || (use_slug && item_id === resource.slug)){
            resource.unlock();
            resource.unlockedByAgenda = true;
            if(resource.unlocked_by.length > 0){
              resource.unlocked_by.forEach(function(higher_resource){
                unlockpath(higher_resource, true);
              })
            }
          }
        })
      }

      var agendas_list = [];
      eventManager.listen('moduleview:agenda:loaded', function(e, data){
        if (data.length > 0)
        {
          scope.hasAgendas = true;
          agendas_list = data;
          scope.selectAgendaPanel();
          data.forEach(function(agenda){
            if(agenda.force_unlock){
              agenda.resources.forEach(function(item){
                unlockpath(item);
              })
            }
        })

        } else {
          scope.hasAgendas = false;
        }
        // $log.log('got agenda info : ', scope.hasAgendas)
        // scope.toggleAgenda();
      });

      scope.hasAgendaOption = function(){
        return scope.hasAgendas;
      }
      scope.hasModuleOption = function(){
        return true && scope.currentActiveSubModule && scope.currentActiveSubModule.children;
      }

      scope.isShowingAgendaPanel = function(){
        return scope.showAgenda;
      }
      scope.isShowingModulePanel = function(){
        return (!scope.showAgenda && !TeacherDataService.isTeacherWorkspaceView);
      }

      scope.toggleAgenda = function() {
        if (scope.showAgenda) {
          // scope.selectModulePanel();
        }
        else {
          scope.selectAgendaPanel();
        }
      }

      scope.selectAgendaPanel = function(){
        if (!scope.showAgenda){
          scope.showAgenda = true;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          eventManager.broadcast('moduleview:agenda:request');
        }
      }

      scope.selectModulePanel = function(){
        if (scope.showAgenda){
          scope.showAgenda = false;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          for (var i = 0; i < items.length; i++) {
            items[i].undoAgendaHighlight();
          }
        }
      }
      scope.getTranslation = function(slug){
        return language.get(slug);
      }

      scope.panelDisplay = {};
      scope.getLang = language.get;

      scope.isStudent = function(){
        return !userAccount.getData().role.isTeacher;
      }
      /////////////
      // CONSTRUCTOR
      /////////////

      var _TOUCHED_POINTS = []
      function init() {
        //scope.isNotTeacherWorkspaceView = !TeacherDataService.isTeacherWorkspaceView;
        // retrieve template element references
        canvas_el = document.getElementById(CANVAS_EL_ID);
        // $log.log('INITING C4 MAP', canvas_el)
        if (!canvas_el) {
          return;
        }

        app = new PIXI.Application(300, 300, {
          autoResize: true,
          //backgroundColor: 0x46a0d7,
          backgroundColor: 0xdee9fc,
          antialias: true,
          view: canvas_el
        });

        MapStateService.setMetaStateSlug('mtic_c4_m_meta')

        var cvs = document.createElement('canvas');
        cvs.width = 1;
        cvs.height = 64;
        var ctx = cvs.getContext('2d');
        var gradient = ctx.createLinearGradient(0,0,0,64);
        gradient.addColorStop(0,'#0087ca');
        gradient.addColorStop(1,'#a7d3ec');
        ctx.fillStyle = gradient;
        ctx.fillRect(0,0,1,64);
        meta_gradient = new PIXI.Sprite(PIXI.Texture.fromCanvas(cvs));

        meta_bg = PIXI.Sprite.fromImage(C4_ASSET_URL + 'background.png')
        meta_bg.anchor.set(0.5,1);


        repeating_clouds = new PIXI.extras.TilingSprite(PIXI.Texture.fromImage(C4_ASSET_URL + 'background_clouds.png'));
        repeating_clouds.anchor.set(0,1);
        repeating_clouds.height = 60;

        renderer = app.renderer;
        scale = 0.45;
        items = [];

        drag_info = learningMapUtil.getDragInfoSettings();

        var sidepanel_width = 0;
        if(scope.isTeacher){
          var sidepanel = document.getElementById('teacher_sidepanel');
          sidepanel_width = TeacherDataService.inTeacherAgendaView ? 60 : sidepanel.offsetWidth;
          if(TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView){
            sidepanel_width += -30;
          }
        }

        canvasDimention = {
          width: window.innerWidth - 180 - sidepanel_width,
          height: window.innerHeight - 50,
        }

        stage = app.stage;
        stage.interactive = true;

        cloud_man = learningMapUtil.createCloudManager();
        stage.addChild(cloud_man.overlay_sprite);


        window.addEventListener("resize", onResize);


        container = new PIXI.Sprite();
        container.interactive = true;


        meta_container = new PIXI.Sprite();
        //meta_container.scale.set(0.5);
        // if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1200){
        //   meta_container.scale.set(0.4);
        // }

        //scale = renderer.width < 800 ? Math.max(0.2655, 0.45 * renderer.width/800) : scale;
        //meta_container.scale.set(scale, scale);
        meta_container.x = renderer.width/2 ;
        meta_container.y = renderer.height/2;

        stage.addChildAt(meta_container, 0);

        renderer.render(stage);
        // if(TeacherDataService.isTeacherWorkspaceView){
        //   stage.x = -200;
        // }

        container.x = renderer.width / 2;
        container.y = renderer.height / 2 - 60;
        stage.addChildAt(container, 0);
        stage.addChildAt(meta_bg, 0);
        stage.addChildAt(repeating_clouds, 0);
        stage.addChildAt(meta_gradient, 0);

        lines_graphic = new PIXI.Graphics();
        container.addChild(lines_graphic);


        container.scale.set(scale, scale);
        app.ticker.add(update);

        canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
        canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else

        // prevent browser from selecting other html text when double clicking the PIXI canvas
        canvas_el.addEventListener('pointerdown', handleDoubleClick, false);

        stage.on('pointerdown', function(e) {
          var e_o = e.data.originalEvent;
          _TOUCHED_POINTS.push({ pointer_id: e_o.pointerId, x:e_o.pageX, y:e_o.pageY});

          drag_info.dragging = true;

          focus_item = null;

          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: container.x,
            y: container.y
          };
          drag_info.start_drag_pos_meta = {
            x: meta_container.x,
            y: meta_container.y
          };
          drag_info.start_drag_mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };

        });

        stage.on('pointermove', function(e) {
          if (!drag_info.dragging) {
            return;
          }
          var mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          }

          if(!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0){
            meta_container.position.x = Math.min(1000, Math.max(drag_info.start_drag_pos_meta.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x), 0));
            meta_container.position.y = Math.min(1000, Math.max(drag_info.start_drag_pos_meta.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y), 0));
          }else{
            container.position.x = Math.min(1000, Math.max(drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x), 0));
            container.position.y = Math.min(1000, Math.max(drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y), 0));
          }

          var delta_pos = {
            x: drag_info.last_mouse_pos.x - mouse_pos.x,
            y: drag_info.last_mouse_pos.y - mouse_pos.y
          };

          drag_info.velocity = {
            x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
            y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
          };

          drag_info.last_mouse_pos = {
            x: mouse_pos.x,
            y: mouse_pos.y
          };
        })

        stage.on('pointerup', function(e) {
          if (window.DEBUG_TOUCH){ $log.log('c4 pointerup ; ', JSON.stringify(drag_info), e); }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function(point, index) {
            if(point.pointer_id === e.pointerId){
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
        });

        stage.on('pointerout', function(e) {
          if (window.DEBUG_TOUCH){ $log.log('c4 pointerup ; ', JSON.stringify(drag_info), e); }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function(point, index) {
            if(point.pointer_id === e.pointerId){
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
        });

        verlet_system.toggle(false);

        if (window.DEBUG_TOUCH){ $log.log('c4 pointerdown ; ', JSON.stringify(drag_info)); }

        eventManager.broadcast('teacherStudentWorkspace:studentFilter:request');

        return loadAssets().then(function() {
          $log.debug('[[gr78MetaMap]] loadAssets.then');
          scope.loading_done = true;
          var isExpanded = TeacherDataService.inTeacherAgendaView ? false : null
          onResize(isExpanded);
          return;
        }).catch(function(err) {
          $log.error('[[gr78MetaMap]] loadAssets.then', err.message)
          $log.debug(err.stack)
        });

      }

      scope.returnToMetaModules = function() {
        eventManager.broadcast('module:change:meta', 'c4_meta_module');
      }

      eventManager.listen('module:change:meta', function(e, data) {
        $timeout(function() {
          //Remove the focus from the selected item
          eventManager.broadcast('module:dismiss:focus');
          scope.currentActiveSubModule = {};
          scope.panelDisplay = {
            slug: '',
            isExpanded: false,
            sub: {}
          };

          verlet_system.deactivateAllBodies(true);
          meta_container.visible = true;
          onResize();

        }, TIMING_CONSTANTS.INSTANT);
      });

      eventManager.listen('unlock-item', function(e, slug){
        items.forEach(function(resource){
          if(slug === resource.slug){
            resource.unlock(true);
            resource.unlockedByAgenda = true;
          }
        })
        // var scopeResource = getResourceBySlug(slug);
        // scopeResource.locked = false;
      })
      eventManager.listen('module:change:submodule', function(e, data) {
        $timeout(function() {
          verlet_system.deactivateAllBodies(true);
          meta_container.visible = false;
          MapStateService.setActiveModule(data);


          var resources = MapStateService.getSelectedResourcesForAgendaCreation();
          for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
            if (scope.moduleMapData.resources[i].slug === data) {
              scope.currentActiveSubModule = scope.moduleMapData.resources[i];
              var resource = scope.moduleMapData.resources[i];
              for (var n = 0; n < resource.children.length; n++) {
                var item = getItemBySlug(resource.children[n].slug);
                if(item && TeacherDataService.isTeacherWorkspaceView)
                {
                    item.hideAgendaHighlight();
                }
                // if((resources && resources.contains && resources.contains(item.id))){
                //   item.showAgendaHighlight();
                // }
                if (DEV_VARIABLES.RESOURCES.HIDE_THESE.indexOf(resource.children[n].slug) > -1||(resource.children[n].config && resource.children[n].config.hidden===true))
                {
                  continue;
                }
                verlet_system.activateBody(resource.children[n].slug, true);
              }
              break;
            }
          }
          language.setAvailableOptions(
            _.get(scope.currentActiveSubModule, ['content', 'available_languages', LocaleService.getUrlVersion() ] )
          );
          if (scope.currentActiveSubModule.display && scope.currentActiveSubModule.display.panel) {
            scope.panelDisplay = {
              slug: scope.currentActiveSubModule.slug,
              isExpanded: true,
              sub: scope.currentActiveSubModule.display.panel
            };
          }
        }, TIMING_CONSTANTS.INSTANT);
      })

      eventManager.listen('module:open:resource', function(e, data){
        MapStateService.setFocusSlug(data.slug);
      })

      var prehighlighted_list = [];
      eventManager.listen('highlight:map:items', function(e,list){
        // $log.log('got prehighlighted list : ', list)
        prehighlighted_list = list;
        $timeout(function(){
          onResize();
        }, 500)
      });

      eventManager.listen('module:select:resource', function(e, data) {
        var scopeResource = getResourceBySlug(data.slug);
        if (scopeResource === null){
          eventManager.broadcast('module:dismiss:focus')
          return;
        }
        if (data.locked) {
          scopeResource.locked = true;
        }
        if(scope.onItemClick && scope.interceptClick){
          var item = getItemBySlug(data.slug);
          scope.onItemClick(scopeResource,item, data);
        }
        $timeout(function(){
          scope.selectedResource = scopeResource;

        }, TIMING_CONSTANTS.INSTANT);

        var mapResource = getItemBySlug(data.slug);
        //This isn't a map item??
        if (mapResource === null){
          return;
        }

        focus_item = mapResource;

        scope.scale_factor = focus_item && focus_item.type === 'assessment' && focus_item.config.assessment_type !== 'formative' ? 9.6 : 10;

        verlet_system.setConstraintLength(60);

        mapResource.sprite.addChildAt(selection_graphic, 0);
        selection_graphic.scale.set(0);

        //Find the module that contains the selected item and open it
        var module_slug = '';
        for (var i = 0; i < scope.moduleMapData.resources.length; i++)
        {
          if (scope.moduleMapData.resources[i].children.indexOf(scopeResource) > -1 )
          {
            if (MapStateService.getActiveModule() !== scope.moduleMapData.resources[i].slug)
            {
              eventManager.broadcast('module:change:submodule', scope.moduleMapData.resources[i].slug);
              eventManager.broadcast('update:submodule:slug:route:name',{slug:scope.moduleMapData.resources[i].slug,name:scope.moduleMapData.resources[i].name});
              MapStateService.setActiveModule(scope.moduleMapData.resources[i].slug)
            }
          }
        }

        if(TeacherDataService.inTeacherAgendaView && !middle_view_visible){
          middle_view_visible = true;
          onResize();
        }


      })

      eventManager.listen('module:center:resource', function(e, data) {
        focus_item = getItemBySlug(data.slug);
      })

      eventManager.listen('module:stop:pan', function() {
        focus_item = null;
      })

      /////////////
      // METHODS
      /////////////

      //Mousewheel zoom/in out at cursor position (like google maps)
      var handleScroll = function(evt) {
        if (!evt) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = (evt.detail < 0 || evt.wheelDelta > 0) ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = scale;
        scale = Math.max(Math.min(1.0, scale + direction / 15), 0.25);
        var diff = scale - start_scale;
        container.scale.set(scale, scale);
        meta_container.scale.set(scale, scale);

        //multiply the local mouse position in the resized map by the change in scale and TRANSLATE
        // var pos = renderer.plugins.interaction.eventData.data.getLocalPosition(container);
        // container.position.x -= diff * pos.x;
        // container.position.y -= diff * pos.y;

        evt.preventDefault();
        return false;
      };

      var handleDoubleClick = function(e) {
        e.preventDefault();
        return false;
      };

      var initMapDraw = function(moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        var combinedResourceMap = {};

        _.forEach(moduleMapData.children, function(someItem) {
          combinedResourceMap[someItem.slug] = someItem;
          loadChildren(someItem);
        })

        _.each(combinedResourceMap, function(resource) {
          createItem(resource, null);
        })
        _.forEach(items, function(item) {
          if (!item.locked) {
            item.unlock();
          }
          if (MapDataMassage.getTempUnlocks()) {
            if (_.indexOf(MapDataMassage.getTempUnlocks(), item.slug) !== -1) {
              item.unlock();
            }
          }
        })
        if(agendas_list.length > 0){
          agendas_list.forEach(function(agenda){
            if(agenda.force_unlock){
              agenda.resources.forEach(function(item){
                unlockpath(item);
              })
            }
          })
        }

        eventManager.broadcast('creating-items-done')
      };

      var updateItemsHighlighterAnimation = function(){
        angular.forEach(items,function(each){
          if(each.selection_graphic){
            //Rotate it a little bit
            each.selection_graphic.rotation = (each.selection_graphic.rotation-0.015)%(Math.PI*2);

            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            each.selection_graphic.scale.set((each.selection_graphic.scale.x * 9 + (0.8+Math.sin(Date.now()/500.0)/10)) /scope.scale_factor);
          }

          if(each.highlight_graphic){
            //Rotate it a little bit
            each.highlight_graphic.rotation = (each.highlight_graphic.rotation-0.015)%(Math.PI*2);

            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            each.highlight_graphic.scale.set((each.highlight_graphic.scale.x * 9 + (0.8+Math.sin(Date.now()/500.0)/10)) /10);
          }
        });
      }
      //This loops to control things that should update every frame
      var update = function() {
        if(selection_graphic !== null && !scope.interceptClick)
        {
          //Rotate it a little bit
          selection_graphic.rotation = (selection_graphic.rotation-0.015)%(Math.PI*2);

          //Use UNIX time to scale the graphic with a sin function
          //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')

          selection_graphic.scale.set((selection_graphic.scale.x * 9 + (0.8+Math.sin(Date.now()/500.0)/10)) /scope.scale_factor);
        }

        if(TeacherDataService.isTeacherWorkspaceView){
          updateItemsHighlighterAnimation();
        }
        //update the fade in animation
        cloud_man.update();

        //update the verlet force directed graph that positions the map items in that big jiggly web
        verlet_system.update();
        //   drawMapLines();
        if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
          drag_info.velocity = {
            x: drag_info.velocity.x * 0.954,
            y: drag_info.velocity.y * 0.954
          };
        } else {
          //If they're not dragging, move the map based on its inertia and damp the inertia
          if(!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0){
            meta_container.position.x = Math.min(1000, Math.max(meta_container.position.x - drag_info.velocity.x, 0));
            meta_container.position.y = Math.min(1000, Math.max(meta_container.position.y - drag_info.velocity.y, 0));
          }else{
            container.position.x = Math.min(1000, Math.max(container.position.x - drag_info.velocity.x, 0));
            container.position.y = Math.min(1000, Math.max(container.position.y - drag_info.velocity.y, 0));
          }

          drag_info.velocity.x *= 0.84;
          drag_info.velocity.y *= 0.84;
        }
        focusItemTicker();

        lines_graphic.clear();
        lines_graphic.lineStyle(8, 0xCCCCDD, 1);
        var segments = verlet_system.getLineSegments();
        var i;
        for (i = 0; i < segments.solid.length; i++) {
          var cur_seg = segments.solid[i];
          lines_graphic.lineStyle(8, 0xCCCCDD, 1);
          if(scope.item_path_slug.indexOf(cur_seg.id) > -1){
            lines_graphic.lineStyle(8, 0XFFCC00, 1);
          }
          lines_graphic.moveTo(cur_seg.start.x, cur_seg.start.y);
          lines_graphic.lineTo(cur_seg.end.x, cur_seg.end.y);
        }
        lines_graphic.beginFill(0xFF0000, 1);
        for (i = 0; i < segments.dash.length; i++) {
          lines_graphic.drawCircle(segments.dash[i].x, segments.dash[i].y, 1.5);
        }
        lines_graphic.endFill();

        if (window.DEBUG_TOUCH){ $log.log('c4 update ; ', JSON.stringify(drag_info)); }
      };

      scope.item_path_slug = [];
      function createHighlightedSegments(slug){
        if(!slug){
          scope.item_path_slug = [];
          return;
        }
        items.forEach(function(resource){
          if(slug === resource.slug){
            scope.item_path_slug.push(slug);
            if(resource.unlocked_by.length > 0){
              resource.unlocked_by.forEach(function(higher_resource){
                createHighlightedSegments(higher_resource);
              })
            }
          }
        })
        // $log.log('scope.item_path_slug , ', scope.item_path_slug)
      }

      eventManager.listen('highlight:path', function(e, data){
        scope.item_path_slug = [];
        // $log.log('HIGHLIGHT THIS : ', data)
        // var use_slug = data.slug.split(':')[1].trim();
        var use = data.slug;
        if(data.clear){
          use = false;
        }
        createHighlightedSegments(use);
      })

      /**
       *Expand a subgroup to reveal child items
       *slug is a unique String that identifies the group MapItem
       **/
      var expandGroup = function(slug) {
        //Cancel this mouse event if they were dragging more than 10 pixels
        if (drag_info.dragging) {
          if (Math.pow(container.x - drag_info.start_drag_pos.x, 2) + Math.pow(container.y - drag_info.start_drag_pos.y, 2) > 100) {
            return;
          }
        }

        if (verlet_system.deactivateBody(slug, true)) {
          var group = getItemBySlug(slug);
          //position all of the sub items so that they appear from where the clicked group icon is
          for (var i = 0; i < items.length; i++) {
            if (items[i].parentItem === group) {
              items[i].sprite.position.x = group.sprite.position.x;
              items[i].sprite.position.y = group.sprite.position.y;
              verlet_system.activateBody(items[i].slug, true);
            }
          }
          // toggleGroupExpanded(group);
        }
      }

      /**
       *Collapse a subgroup to hide child items
       *slug is a unique String that identifies the group MapItem
       **/
      var collapseGroup = function(slug) {
        var group = getItemBySlug(slug);
        if (group.isExpanded === true) {
          toggleGroupExpanded(group);
        }
      }

      /**
       *Toggle the expand/collapse of a given item group
       *group is a MapItem
       **/
      var toggleGroupExpanded = function(group) {
        group.isExpanded = !group.isExpanded;
        //    baseVerletSystem.hookUpConstraints();
      }

      //If focus item is defined, pan towards it
      var focusItemTicker = function() {
        if (focus_item === null) {
          return;
        }
        var abs_pos = container.toGlobal(focus_item.sprite.position);
        container.x += -(abs_pos.x - 125 - app.renderer.width / 2) / 10;
        container.y += -(abs_pos.y + 80 - app.renderer.height / 2) / 10;
      }

      /**
       *Return a MapItem whose slug matches the passed slug
       *Returns null if no MapItem can be found
       */
      var getItemBySlug = function(slug) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].slug === slug) {
            return items[i];
          }
        }
        return null;
      }

      var getItemById = function(id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
        }
        return null;
      }

      var getResourceBySlug = function(slug)
      {
        var i, n;
        for (n = 0; n < scope.moduleMapData.resources.length; n ++)
        {
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++)
          {
            if (scope.moduleMapData.resources[n].children[i].slug === slug)
            {
              return scope.moduleMapData.resources[n].children[i];
            }
          }
        }
        return null;
      }

      ////////////////
      //
      ////////////////
      var onResize = function(sidepanel_expanded) {
        var _canvasEl = document.getElementById(CANVAS_EL_ID)
        if (!_canvasEl) {
          return;
        }

        var sidepanel_width = TeacherDataService.sidepanelStatus ? 260:60;
        var canv_width;
        // var sidepanel = document.getElementById('teacher_sidepanel');
        if(!TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView){
          if(sidepanel_expanded === true || sidepanel_expanded === false){
            sidepanel_width = sidepanel_expanded ? 140 : -200;
          }else{
            sidepanel_width = 0;
          }
          canv_width =  _canvasEl.parentElement.offsetWidth - sidepanel_width;
        }else{
          var middleview = document.getElementById('agenda_middleview');
          if(middleview){
            sidepanel_width += 300
          }
          if(!TeacherDataService.inTeacherAgendaView){
            sidepanel_width += -30;
          }
          canv_width = window.innerWidth - 370 - sidepanel_width;
        }

        canvasDimention = {
          width: canv_width,
          height: window.innerHeight - 35
        }

        _canvasEl.width = canvasDimention.width;
        _canvasEl.height = canvasDimention.height;

        renderer.resize(canvasDimention.width, canvasDimention.height);
        cloud_man.onResize(canvasDimention.width, canvasDimention.height);

        meta_bg.position.x = canvasDimention.width / 2;
        meta_bg.position.y = canvasDimention.height - 8;

        repeating_clouds.position.y = canvasDimention.height - 8;
        repeating_clouds.width = canvasDimention.width;

        scale = renderer.width < 800 ? Math.max(0.2655, 0.45 * renderer.width/800) : scale;
        meta_container.scale.set(scale, scale);
        meta_container.x = renderer.width/2;
        meta_container.y = renderer.height/2;

        container.scale.set(scale, scale);
        container.x = renderer.width/2;
        container.y = renderer.height/2;

        meta_gradient.width = canvasDimention.width;
        meta_gradient.height = canvasDimention.height;

      };

      // scope.$watch("moduleMapData", function (moduleMapData) {

      //this is what runs to initialize the map
      var loadAssets = function() {
        $log.debug('[[gr78MetaMap]] loadAssets')
        return $q(function(resolve, reject) {
          try {
            if (!PIXI_gr78_Load_Cache || !PIXI_c4_Load_Cache) {
              PIXI.loader.reset();

              if (!PIXI_gr78_Load_Cache)
              {
                PIXI.loader.add(img_asset_paths);
              }
              if (!PIXI_c4_Load_Cache)
              {
                PIXI.loader.add(c4_asset_paths);
              }

              PIXI.loader.load(function() {
                  PIXI_gr78_Load_Cache = true;
                  PIXI_c4_Load_Cache = true;
                  initMap(resolve);
                })
            } else {
              initMap(resolve);
            }
          } catch (err) {
            $log.error('[[gr78MetaMap]]', err)
            reject(err);
          }
        })
      }

      var initMap = function(resolve) {
        $log.debug('[[gr78MetaMap]] initMap')

        modules = [];
        var i, n, p;
        for (i = 0; i < scope.moduleMapData.resources.length; i++) {
          initMapDraw(scope.moduleMapData.resources[i]);
          var module_container = createModuleContainer(scope.moduleMapData.resources[i]);
          modules.push(module_container);
          //Add all the bad boys to the verlet_system
        }
        $log.debug('[[gr78MetaMap]] initMap.initMapDraw done')

        verlet_system.deactivateAllBodies(true);

        $log.debug('[[gr78MetaMap]] initMap.verlet_system done')
        var active_module = MapStateService.getActiveModule();
        for (n = 0; n < modules.length; n++) {
          if (modules[n].slug === active_module) {
            moduleClicked(modules[n]);

            var active_items = MapStateService.getActiveItems();

            verlet_system.deactivateAllBodies(true);

            for (p = 0; p < active_items.length; p++) {
              var item = getItemBySlug(active_items[p]);
              var pos = MapStateService.getItemState(active_items[p]);
              item.sprite.position.x = pos.x;
              item.sprite.position.y = pos.y;
              verlet_system.activateBody(active_items[p], true);
            }
          }
        }

        selection_graphic = new PIXI.Sprite(PIXI.loader.resources[GR78_ASSET_URL + 'selection.png'].texture);
        selection_graphic.anchor.set(0.5,0.5);
        selection_graphic.scale.set(0.75,0.75);
        selection_graphic.interactive = false;
        selection_graphic.hitArea = new PIXI.Rectangle(0,0,0,0);

        if (!PanelStateService.agendaShowing())
        {
          scope.toggleAgenda();
        }

        //If an item was selected before we left the map, find it and highlight it as we return.
        var focus_slug = MapStateService.getFocusSlug();
        for (n = 0; n < scope.moduleMapData.resources.length; n ++)
        {
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++) {
            if (scope.moduleMapData.resources[n].children[i].slug === focus_slug) {
              var item_info = scope.moduleMapData.resources[n].children[i];
              var item_evt_info = {
                slug : item_info.slug,
                id : item_info.id
              };
              //brodcast the selection events
              eventManager.broadcast('module:center:resource', item_evt_info);
              eventManager.broadcast('module:select:resource', item_evt_info);

              //center on the resource immediately
              if(focus_item){
                var abs_pos = container.toGlobal(focus_item.sprite.position);
                container.x += -(abs_pos.x - 125 - app.renderer.width / 2);
                container.y += -(abs_pos.y + 80 - app.renderer.height / 2);
              }

              break;
            }
          }
        }
        if (focus_item)
        {
          if (scope.moduleMapData.resources[n] !== undefined && scope.moduleMapData.resources[n].children[i] !== undefined){
            $timeout(function(){
              scope.panelDisplay = scope.moduleMapData.resources[n].children[i];
            }, TIMING_CONSTANTS.INSTANT);
          }
        }


        $log.debug('[[gr78MetaMap]] initMap.active_module done')
        resolve();
      }

      var module_clicked = false;
      var moduleClicked = function(module_container) {
        if(scope.interactionDisabled){
          return;
        }
        module_clicked = true;
        if(ModuleFilter.checkAvailable(module_container)) {
          if(scope.interceptClick){
            if(scope.interceptClick.slug !== module_container.slug){
              scope.interceptClick.slug = module_container.slug;
            }else if(!TeacherDataService.inTeacherAgendaView){
              eventManager.broadcast('retrigger-workspace-filters', scope.interceptClick.slug);
            }
            scope.$apply();
          }
          var i;
          eventManager.broadcast('submodule:opened', {
            slug: module_container.slug,
            name: module_container.name
          });
          $timeout(function() {
              eventManager.broadcast('module:change:submodule', module_container.slug);
          }, TIMING_CONSTANTS.INSTANT);
        }else{
          window.alert(language.get('module_is_locked'))
        }
      }
      var is_module_locked = function(lock_arr){
        for(var i = 0; i < lock_arr.length ; i++){
          var lock_name = lock_arr[i];
          if(LocaleService.checkUrlVersion(lock_name)){
            return true;
          }
        }
        return false;
      }

      var createModuleContainer = function(module, reset) {
        //Set up the container sprite that will be used
        var do_lock = module.locked;
        //$log.log("MODULE : " , module)//DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(module.slug) > -1
        // $log.log('ModuleFilter.checkAvailable(module)', ModuleFilter.checkAvailable(module))
        if (!ModuleFilter.checkAvailable(module)) {
          do_lock = true;
        }

        //For drawing progress ring
        var sum = 0;
        var prog = 0;
        for (var i = 0; i < module.children.length; i++)
        {
          if (module.children[i].resource_type === 'symlink' || (module.children[i].resource_type === 'assessment'  && module.children[i].config.assessment_type && module.children[i].config.assessment_type === 'formative'))
          {
            continue;
          }
          sum ++;
          if(TeacherDataService.isTeacherWorkspaceView){
            prog += workspace_list[module.children[i].id] ? 1 : 0;
          }else{
            prog += module.children[i].complete ? 1 : 0;
          }
        }
        if(TeacherDataService.isTeacherModuleView){
          prog = 0;
        }
        var mod_names = ['c4_m1', 'c4_m2', 'c4_m3', 'c4_m4', 'c4_m5', 'c4_m6'];
        var mod_graphics;
        if(reset){
          modules.forEach(function(mod){
            if(mod.slug === module.slug){
              mod_graphics = mod.graphics;
            }
          })
          //mod_graphics = container.getChildAt(0);
          if(!mod_graphics){
            return;
          }
          mod_graphics.clear()
        }else{
          mod_graphics = new PIXI.Graphics();
        }

        if (do_lock) {
          mod_graphics.beginFill(0xC5FBF5).drawCircle(0, 0, 130).endFill() //white border for lock
        }



        mod_graphics.buttonMode = true;
        mod_graphics.interactive = true;

        if (mod_names.indexOf(module.slug) > -1)
        {
          var mod_sprite =  PIXI.Sprite.fromImage(do_lock ? GR78_ASSET_URL + 'center_lock.png' : C4_ASSET_URL + module.slug + '.png');
          mod_sprite.scale.set(do_lock ? 1.4 : 2);
          mod_sprite.anchor.set(0.5);
          mod_graphics.addChild(mod_sprite);
        }

        var textInfo = new PIXI.Text(language.get(module.slug), {
          fontFamily: 'Arial',
          align: 'center',
          fontSize: isMobile ? 38 : 22,
          fill: 0xFFFFFF,
        });
        textInfo.y = 25;
        textInfo.anchor.set(0.5);
        var text_width = textInfo.width

        var tooltip = new PIXI.Graphics();
        tooltip.beginFill(do_lock ? 0x63a19a : 0x0971b3)
          .drawRoundedRect(-(text_width+40)/2,0, text_width+40, 75, 10);
        tooltip.moveTo(-15,75);
        tooltip.lineTo(15,75);
        tooltip.lineTo(0,100);
        tooltip.lineTo(-15,75);

        tooltip.endFill();
        tooltip.beginFill(0x075a8f);
        tooltip.drawRect(-(text_width+40)/2+10, 45, text_width+20, 15);
        tooltip.endFill();

        tooltip.beginFill(0x33ccff);
        tooltip.drawRect(-(text_width+40)/2+10, 45, (text_width+20) * (prog/sum), 15);
        tooltip.endFill();

        tooltip.y = -220;
        //tooltip.x -= (text_width+40)/2
        mod_graphics.addChild(tooltip);

        meta_container.addChild(mod_graphics);
        //meta_container.scale.set(0.5);

        // if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1200){
        //   meta_container.scale.set(0.4);
        // }
        mod_graphics.buttonMode = true;
        mod_graphics.interactive = true;

        var mod_index = mod_names.indexOf(module.slug);

        mod_graphics.x = (mod_index % 3) * 450 - 450;
        mod_graphics.y = ((mod_index-3 >= 0) ? 400 : 0) - 200;


        eventManager.listen('language:change', function() {
          textInfo.text = language.get(module.slug);
          text_width = textInfo.width;
          tooltip.clear();
          tooltip.beginFill(0x0971b3).drawRoundedRect(-(text_width+40)/2,0, text_width+40, 75, 10);
          tooltip.moveTo(-15,75);
          tooltip.lineTo(15,75);
          tooltip.lineTo(0,100);
          tooltip.lineTo(-15,75);

          tooltip.endFill();
          tooltip.beginFill(0x075a8f);
          tooltip.drawRect(-(text_width+40)/2+20, 45, text_width, 15);
          tooltip.endFill();

          tooltip.beginFill(0x33ccff);
          tooltip.drawRect(-(text_width+40)/2+20, 45, (text_width) * (prog/sum), 25);
          tooltip.endFill();
          textInfo.x = tooltip.width/2 - textInfo.width/2 - 20;
        });
        tooltip.addChild(textInfo);
        textInfo.x = tooltip.width/2 - textInfo.width/2 - 20;


        var module_container = {
          graphics: mod_graphics,
          slug: module.slug,
          name: module.name,
          children: module.children
        };

        if(reset){
          mod_graphics.off('pointertap')
        }
        mod_graphics.on('pointertap', function(e){
          if (e.data.originalEvent.target && e.data.originalEvent.target.id !== 'canvas-c4-module-m1') {
            return;
          }
          $timeout(function(){
            if(!zooming){
              moduleClicked(module_container);
            }
          }, 10)
        });



        eventManager.listen('module:dismiss:focus', function(e, data) {
          scope.selectedResource = {};
          if (selection_graphic.parent !== null)
          {
            selection_graphic.parent.removeChild(selection_graphic);
          }
        });
        var connection = [];

        //verlet_system.createBody(module.slug, mod_graphics, connection);
        return module_container;
      }

      var loadChildren = function(someItem) {
        someItem.childResourcemap = [];

        if (someItem.children === undefined) {
          return;
        }
        if (someItem.children.length > 0) {
          _.forEach(someItem.children, function(childItem) {
            someItem.childResourcemap[childItem.slug] = childItem;
            loadChildren(childItem);
          });
        }
      }
      var interpeteAgendaLockStatus = function(agenda){
        if(agenda.force_unlock === true) {
          return 'unlock';
        } else if(agenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      }

      var summative_list = [];

      eventManager.listen('got-c4-summative-data', function(e, args) {
        $timeout(function(){
          summative_list.forEach(function(summ){
            if(args && args.unlocked.indexOf(summ.name) > -1){
              // $log.log(MapStateService.getActiveModule());
              var name_check = summ.val.slug.replace('g78', 'gr78')
              args.force_unlock = args.force_unlock || [];
              var start_visible = MapStateService.getActiveModule() && summ.val.config.assessment_type === 'summative' && name_check.indexOf(MapStateService.getActiveModule()) > -1;
              createItem(summ.val, summ.parent, !start_visible, true, args.force_unlock.indexOf(summ.name) > -1);
            }
          })
        }, 500)

      });

      var createItem = function(resource, parentItem, start_hidden, build, force_unlock) {
        var isSummative = false;
        if(resource.slug.indexOf('summative') > -1 || resource.config.assessment_type === 'summative'){
          isSummative = true;
          if(!build && !TeacherDataService.isTeacherModuleView && !TeacherDataService.isTeacherWorkspaceView) {
            summative_list.push({name: resource.slug, val: resource, parent: parentItem})
            return;
          }
        }else if (resource.children && resource.children.length > 0) {
            _.forEach(resource.children, function(childItem) {
              createItem(childItem, parentItem);
            });
          return;
        }

        if (verlet_system.getBody(resource.slug) !== undefined) {
          return;
        }
        var displayItem;

        if (TeacherDataService.isTeacherModuleView || TeacherDataService.isTeacherWorkspaceView){
          resource.locked = false;
        }
        //Add this to the map logic array of items
        // $log.log('before call : ', resource)
        var lockedVersions = _.get(resource, ['content', 'lock_on']);
        _.each(lockedVersions, function(currentLock){
          if (LocaleService.checkUrlVersion(currentLock)){
            resource.locked = true;
          }
        })
        items.push(displayItem = new gr78MapItemFactory.createMapItem(resource, eventManager));
        resourceLockManager.setOriginal(displayItem.id, displayItem.locked);
        //create a VerletBody for the item
        displayItem.parentItem = parentItem;
        //     displayItem.sprite.position.x += Math.random() * 10;
        //    displayItem.sprite.position.y += Math.random() * 10;
        container.addChild(displayItem.sprite);

        //Setup verlet body dragging
        /*
          displayItem.sprite.on('pointerdown', function(evt) {
            var dragFunc = function(tickerEvt) {
              var item = displayItem;
              var abs_pos = container.toGlobal(item.sprite.position);
              var xPos = renderer.plugins.interaction.eventData.data.global.x;
              var yPos = renderer.plugins.interaction.eventData.data.global.y;
              if (isNaN(xPos) || isNaN(yPos)) {
                return;
              }
              item.sprite.position.x -= abs_pos.x - xPos;
              item.sprite.position.y -= abs_pos.y - yPos;
            };

            stage.on('pointerup', function(e) {
              app.ticker.remove(dragFunc);
            });

            app.ticker.add(dragFunc);
            evt.stopPropagation();
          });
          */
        var children = [];
        //Build the child items
        _.forEach(resource.children, function(childItem) {
          children.push(createItem(childItem, displayItem, true));
        });

        //If this has children, it is a Group Item (An Item that is not a lesson itself, but a container for a group of lessons)
        //So we create its list of unlocked_by based on the items in the group
        //Find any children whose unlocked_by is not contained in the group (points to an item outside of the group)
        //And add it to the unlocked_by of the group
        if (displayItem.unlocked_by.length === 0) {
          for (var i = 0; i < children.length; i++) {
            for (var n = 0; n < children[i].unlocked_by.length; n++) {
              var is_inner = true;
              for (var p = 0; p < children.length; p++) {
                //This is pointing from an item in the group to another item in the group
                if (children[i].unlocked_by[n] === children[p].slug) {
                  is_inner = false;
                }
              }
              //This isn't pointing to any item inside the group.... so it is pointing to an item outside the group
              if (is_inner) {
                displayItem.unlocked_by.push(children[i].unlocked_by[n]);
              }
            }
          }
        }


        if(!isSummative){
            displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        }else{
            displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, false, !resource.complete);
        }
        if (start_hidden) {
          displayItem.sprite.visible = false;
          verlet_system.deactivateBody(resource.slug);
        }
        displayItem.sprite.position.x = displayItem.sprite.position.x* 15;
        displayItem.sprite.position.y = displayItem.sprite.position.y* 15;
        //Add the expandGroup listener to the item
        if (resource.resource_type === "group") {
          displayItem.setDelegate(expandGroup.bind(this));
          displayItem.isExpanded = false;
        }
        if(isSummative){
          resource.locked = resource.unlocked_by && resource.unlocked_by.length > 0 ? resource.locked : false;
          if(force_unlock){
            displayItem.unlock(true);
          }
          displayItem.sprite.position.x = -900;
          displayItem.sprite.position.y = -500;
        }
        if(prehighlighted_list.indexOf(resource.id) > -1){
          // $log.log('PREHIGHLIGHTING : ', resource.slug)
          $timeout(function(){
            displayItem.showAgendaHighlight(true);
          }, 100);
        }
        return displayItem;
      }
      this.destroy = function() {
        // $log.log('destroying from c4:')
        // scope.hide_baseline_prompt();
        EXISTS = false;
        eventManager.broadcast('c4:hide_student_test');
        if(!scope.inited){
          return;
        }
        MapStateService.setActiveModule("");
        //first save the state
        var active_items = verlet_system.getActiveSlugs();
        PIXI_gr78_Load_Cache = false;

        for (var i = 0; i < active_items.length; i++) {
          var item = getItemBySlug(active_items[i]);
          if(item) {
            MapStateService.setItemState(active_items[i], {
              x: item.sprite.position.x,
              y: item.sprite.position.y
            });
          }
        }

        MapStateService.setActiveItems(active_items);


        $log.debug(" ==== DESTROYING MODULE MAP!!! ==== ");
        if (canvas_el) {
          canvas_el.removeEventListener('DOMMouseScroll', handleScroll); // for Firefox
          canvas_el.removeEventListener('mousewheel', handleScroll); // for everyone else

          // prevent browser from selecting other html text when double clicking the PIXI canvas
          canvas_el.removeEventListener('pointerdown', handleDoubleClick);
        }
        stage.removeChildren();
        container.removeChildren();
        app.destroy();
        window.removeEventListener("resize", onResize);

      }.bind(this)

      scope.$on('$destroy', function() {
        this.destroy();
      }.bind(this));

      scope.$watch("moduleMapData", function(moduleMapData) {

        if (!moduleMapData || EXISTS) {
          return;
        }
        $timeout(()=>{
          EXISTS = true;
          checkForStudentTest();
        })
      })

      eventManager.listen('moduleview:agenda:selected', function(e, agenda) {
        for (var i = 0; i < items.length; i++) {
          //items[i].hideAgendaHighlight();
        }
        if (!agenda || !agenda.resources)
        {
          return;
        }
        switch(interpeteAgendaLockStatus(agenda)) {
          case 'unlock':
            return resourceLockManager.unlock(agenda.resources, true);
          // case 'lock':
          //   return resourceLockManager.lock(agenda.resources);
          // default:
          //   return resourceLockManager.reset();
        }
      });

      // scope.show_baseline = function(){
      //   scope.show_baseline_test_prompt = false;
      //   language.setAvailableOptions(['de'])
      //   eventManager.broadcast('module:open:resource', student_baseline);
      //   showing_student_assesment = true;
      // }

      // scope.hide_baseline_prompt = function(){
      //   scope.show_baseline_test_prompt = false;
      // }

      var workspace_list = {};
      var users_list = [];
      scope.$watch('[workspaceData.users, workspaceData.modules]', function(val){
        var timer = window.isWebEmbedConnect && TeacherDataService.isTeacherWorkspaceView ? 500 : 50;

        $timeout(function(){
          if(scope.workspaceData && scope.workspaceData.modules.length > 0 && (!scope.currentActiveSubModule || !scope.currentActiveSubModule.children)){
            workspace_list = {};
            users_list = [];
            scope.workspaceData.users.forEach( function(user){
              users_list.push(user.user_id);
            })

            scope.workspaceData.modules.forEach( function(work){
              if(users_list.indexOf(work.user_id) > -1){
                workspace_list[work.resource_id] = scope.workspaceData.users.length === 1 && (work.completed || workspace_list[work.resource_id]) ? true : false;
              }
            })

            for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
              var module_container = createModuleContainer(scope.moduleMapData.resources[i], true);
            }
          }
        },timer)

      })

      scope.itemSearchChange = function(val){
        scope.filteredNameList = [];
        if(!scope.itemsNameList){
          return;
        }
        if(val.trim() !== ''){
          scope.filteredNameList = scope.itemsNameList.filter(function(name){
            var nameMod = name.name.toLowerCase();
            var valMod = val.toLowerCase();
            var bool_val;
            try{
              bool_val = nameMod.match(valMod)
            }catch(e){
              bool_val = false
            }
            return bool_val;
          })
        }
        // $log.log('scope.filteredNameList', scope.filteredNameList);
      }

      scope.view_controller = {
        isStudentView: true,
        isModulePanelView: true,
        openSubMod: function(slug){
          // $log.log('opening sub mod:', slug)
          $timeout(function(){
            eventManager.broadcast('module:change:submodule', slug);
          }, 1000)
        },
        openMainMod: function(slug){
          eventManager.broadcast('module:change:meta', 'c4_meta_module');
        }
      }

      eventManager.listen('sidepanel:toggled', function(e, val){
        if(!PlatformService.isPhonePortrait()){
          onResize(val);
        }
      })

      eventManager.listen('hide_item_selection_highlight', function(e, resource){
        var item = getItemBySlug(resource.slug);
        item.hideAgendaHighlight(true);
      })

      eventManager.listen('toggle_item_selection_highlight', function(e, slug){
        var item = getItemBySlug(slug);
        item.showAgendaHighlight();
      })

      var zooming = false;
      scope.zoom_function = function(val){
        handleScroll({detail: val, preventDefault: ()=>{}})
        zooming = true;
        $timeout(function(){
          zooming = false
        }, 10)
      }

      eventManager.listen('offline-post-call-resolved', function(){
        if(!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0 || !module_clicked){
          for(var texture in PIXI.TextureCache){
            var tmp = PIXI.Texture.removeTextureFromCache(texture);
            tmp.destroy(true);
          }
          eventManager.broadcast('refresh:current:tab');
          eventManager.broadcast('student:cycle:open');
        }
      });

    }
  }
});

var PIXI_c4_Load_Cache;
var PIXI_gr78_Load_Cache;
var EXISTS;
